import {FormControl, Grid} from '@mui/material';
import styled from '@emotion/styled';

export const InputFieldGrid = styled(Grid)`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
`;

export const FormControlDiv = styled(FormControl)`
  width: 100%;
`;
